import { RefObject, useEffect, useRef } from 'react';

export const useHeadingSetFocusRef =
  (): RefObject<HTMLHeadingElement | null> => {
    const ref = useRef<HTMLHeadingElement>(null);
    useEffect(() => {
      if (ref.current) {
        ref.current.focus();
      }
    }, []);
    return ref;
  };
